module.exports = __webpack_public_path__ + "static/img/step5.af8a2894.png";